/* Nelomo – Hike layout behaviour. No dependencies. Config: window.GU.config (snippets/gu-head.liquid). */
(function () {
  'use strict';
  var d = document;
  var w = window;
  var C = (w.GU && w.GU.config) || {};
  var R = C.routes || {};
  d.documentElement.classList.add('js-gu');

  function $(sel, root) { return (root || d).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function isDesktop() { return w.matchMedia('(min-width: 1024px)').matches; }
  function canHover() { return w.matchMedia('(hover: hover)').matches; }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  var locks = 0;
  function lock(on) {
    locks = Math.max(0, locks + (on ? 1 : -1));
    d.documentElement.classList.toggle('gu-lock', locks > 0);
  }

  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    var fmt = C.moneyFormat || '{{amount_with_comma_separator}} €';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var type = m ? m[1] : 'amount';
    function f(n, dec, ts, ds) {
      var s = (n / 100).toFixed(dec).split('.');
      return s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ts) + (s[1] ? ds + s[1] : '');
    }
    var v;
    switch (type) {
      case 'amount_no_decimals': v = f(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = f(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = f(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = f(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = f(cents, 2, ' ', ','); break;
      default: v = f(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }

  var toastEl;
  var toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = d.createElement('div');
      toastEl.className = 'gu-toast';
      toastEl.setAttribute('role', 'status');
      d.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  function setHeaderHeight() {
    var hg = d.getElementById('header-group');
    if (hg) d.documentElement.style.setProperty('--gu-hg', hg.getBoundingClientRect().height + 'px');
  }

  /* ---------- announcement ---------- */
  function initAnnouncement(root) {
    $$('[data-gu-ann]', root).forEach(function (bar) {
      if (bar._guTimer) clearInterval(bar._guTimer);
      var slides = $$('.gu-ann__slide', bar);
      if (slides.length < 2) return;
      if (w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0, paused = false;
      /* readers can stop the rotation: pause while hovered or focused */
      ['mouseenter', 'focusin'].forEach(function (ev) { bar.addEventListener(ev, function () { paused = true; }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { bar.addEventListener(ev, function () { paused = false; }); });
      bar._guTimer = setInterval(function () {
        if (paused) return;
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, 5000);
    });
  }

  /* ---------- mega menu ---------- */
  function closeMegas(except) {
    $$('[data-gu-nav-item].is-open').forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      var t = $('[data-gu-nav-trigger]', item);
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  function initMega(root) {
    $$('[data-gu-nav-item].has-mega', root).forEach(function (item) {
      if (item._gu) return;
      item._gu = true;
      var trigger = $('[data-gu-nav-trigger]', item);
      var timer;
      function open() {
        clearTimeout(timer);
        closeMegas(item);
        item.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }
      function close() {
        clearTimeout(timer);
        item.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
      item.addEventListener('mouseenter', function () {
        if (!canHover()) return;
        clearTimeout(timer);
        timer = setTimeout(open, 90);
      });
      item.addEventListener('mouseleave', function () {
        if (!canHover()) return;
        clearTimeout(timer);
        timer = setTimeout(close, 180);
      });
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          if (!canHover() && !item.classList.contains('is-open')) { e.preventDefault(); open(); }
        });
      }
    });
  }

  /* ---------- search panel + predictive search ---------- */
  function initSearch(root) {
    var header = $('[data-gu-header]', root);
    if (!header || header._guSearch) return;
    header._guSearch = true;
    var panel = $('[data-gu-search-panel]', header);
    if (!panel) return;
    var results = $('[data-gu-search-results]', panel);
    var inputs = $$('[data-gu-search-input]', header);
    var ctrl = null;
    var timer = null;
    var isOpen = false;

    function open() {
      if (isOpen) return;
      isOpen = true;
      closeMegas();
      setHeaderHeight();
      panel.hidden = false;
      if (!isDesktop()) lock(true);
      /* the panel's own input is used on mobile and on laptops where the header field is hidden */
      var hdr = $('.gu-search--header input', header);
      if (!isDesktop() || !hdr || !hdr.offsetParent) {
        var inp = $('.gu-search--panel input', panel);
        if (inp) setTimeout(function () { inp.focus(); }, 60);
      }
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      panel.hidden = true;
      if (!isDesktop()) lock(false);
    }
    function query(q) {
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in w ? new AbortController() : null;
      var url = (R.predictiveSearch || '/search/suggest') + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page&resources[limit]=4&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=gu-predictive-search';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var ps = parseHTML(html).querySelector('.gu-ps');
          results.innerHTML = ps ? ps.outerHTML : '';
          panel.classList.add('is-results');
        })
        .catch(function () {});
    }
    inputs.forEach(function (inp) {
      inp.addEventListener('focus', open);
      inp.addEventListener('input', function () {
        var q = inp.value.trim();
        inputs.forEach(function (o) { if (o !== inp) o.value = inp.value; });
        clearTimeout(timer);
        if (q.length < 2) {
          panel.classList.remove('is-results');
          results.innerHTML = '';
          return;
        }
        timer = setTimeout(function () { query(q); }, 220);
      });
    });
    $$('[data-gu-search-open]', header).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    $$('[data-gu-search-close]', panel).forEach(function (b) { b.addEventListener('click', close); });
    d.addEventListener('click', function (e) {
      if (!isOpen || !isDesktop()) return;
      if (!header.contains(e.target)) close();
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- mobile menu drawer ---------- */
  function drawerEl() { return $('[data-gu-drawer]'); }
  function openDrawer() {
    var dr = drawerEl();
    if (!dr || dr.classList.contains('is-open')) return;
    dr.classList.add('is-open');
    dr.setAttribute('aria-hidden', 'false');
    lock(true);
  }
  function closeDrawer() {
    var dr = drawerEl();
    if (!dr || !dr.classList.contains('is-open')) return;
    dr.classList.remove('is-open');
    dr.setAttribute('aria-hidden', 'true');
    lock(false);
    setTimeout(function () {
      $$('[data-gu-level]', dr).forEach(function (l) { l.classList.remove('is-active', 'is-behind'); });
      var rootLevel = $('[data-gu-level="root"]', dr);
      if (rootLevel) rootLevel.classList.add('is-active');
    }, 320);
  }

  /* ---------- cart ---------- */
  var Cart = {
    el: function () { return $('[data-gu-cart-drawer]'); },
    ids: function () {
      var ids = [];
      var dr = this.el();
      if (dr) ids.push(dr.getAttribute('data-section-id'));
      var pg = $('[data-gu-cart-page]');
      if (pg) ids.push(pg.getAttribute('data-section-id'));
      return ids;
    },
    open: function () {
      var dr = this.el();
      if (!dr) { w.location.href = R.cart || '/cart'; return; }
      if (dr.classList.contains('is-open')) return;
      closeDrawer();
      dr.classList.add('is-open');
      dr.setAttribute('aria-hidden', 'false');
      lock(true);
      var btn = $('[data-gu-cart-close].gu-icon-btn', dr);
      if (btn) setTimeout(function () { btn.focus(); }, 80);
    },
    close: function () {
      var dr = this.el();
      if (!dr || !dr.classList.contains('is-open')) return;
      dr.classList.remove('is-open');
      dr.setAttribute('aria-hidden', 'true');
      lock(false);
    },
    setCount: function (n) {
      $$('[data-gu-cart-count]').forEach(function (b) {
        b.textContent = n;
        b.hidden = !n;
        b.classList.remove('is-bump');
        void b.offsetWidth;
        b.classList.add('is-bump');
      });
    },
    render: function (sections) {
      if (!sections) return;
      var count = null;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var doc = parseHTML(html);
        var freshInner = doc.querySelector('[data-gu-cart-inner]');
        var dr = Cart.el();
        if (freshInner && dr && dr.getAttribute('data-section-id') === id) {
          var inner = $('[data-gu-cart-inner]', dr);
          inner.innerHTML = freshInner.innerHTML;
          inner.setAttribute('data-count', freshInner.getAttribute('data-count'));
          count = +freshInner.getAttribute('data-count');
        }
        var freshPage = doc.querySelector('[data-gu-cart-page]');
        var page = $('[data-gu-cart-page]');
        if (freshPage && page && page.getAttribute('data-section-id') === id) {
          page.innerHTML = freshPage.innerHTML;
        }
      });
      if (count !== null) this.setCount(count);
    },
    request: function (url, body, isForm) {
      var opts = { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body };
      if (!isForm) opts.headers['Content-Type'] = 'application/json';
      return fetch(url, opts).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || j.status) throw j;
          return j;
        });
      });
    },
    refreshCountFallback: function () {
      if (this.el()) return;
      fetch((R.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { Cart.setCount(c.item_count); })
        .catch(function () {});
    },
    add: function (fd) {
      var ids = this.ids();
      if (ids.length) {
        fd.append('sections', ids.join(','));
        fd.append('sections_url', w.location.pathname);
      }
      return this.request((R.cartAdd || '/cart/add') + '.js', fd, true).then(function (j) {
        Cart.render(j.sections);
        Cart.refreshCountFallback();
        return j;
      });
    },
    change: function (key, qty) {
      var ids = this.ids();
      var body = { id: key, quantity: qty };
      if (ids.length) { body.sections = ids; body.sections_url = w.location.pathname; }
      return this.request((R.cartChange || '/cart/change') + '.js', JSON.stringify(body)).then(function (j) {
        Cart.render(j.sections);
        if (typeof j.item_count === 'number') Cart.setCount(j.item_count);
        return j;
      });
    },
    swap: function (key, qty, variantId) {
      return this.request((R.cartChange || '/cart/change') + '.js', JSON.stringify({ id: key, quantity: 0 })).then(function () {
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', qty);
        return Cart.add(fd);
      });
    }
  };

  function lineError(err) {
    toast((err && (err.description || err.message)) || C.strings.error || 'Fehler');
  }

  d.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-gu-drawer-open]'))) { e.preventDefault(); openDrawer(); return; }
    if ((el = t.closest('[data-gu-drawer-close]'))) { e.preventDefault(); closeDrawer(); return; }
    if ((el = t.closest('[data-gu-level-open]'))) {
      var target = d.getElementById(el.getAttribute('data-gu-level-open'));
      var current = el.closest('[data-gu-level]');
      if (target && current) {
        current.classList.remove('is-active');
        current.classList.add('is-behind');
        target.classList.add('is-active');
        target.scrollTop = 0;
        target._guPrev = current;
      }
      return;
    }
    if ((el = t.closest('[data-gu-level-back]'))) {
      var lvl = el.closest('[data-gu-level]');
      if (lvl && lvl._guPrev) {
        lvl.classList.remove('is-active');
        lvl._guPrev.classList.remove('is-behind');
        lvl._guPrev.classList.add('is-active');
      }
      return;
    }
    if ((el = t.closest('[data-gu-cart-open]'))) {
      if (Cart.el()) { e.preventDefault(); Cart.open(); }
      return;
    }
    if ((el = t.closest('[data-gu-cart-close]'))) { e.preventDefault(); Cart.close(); return; }

    var line = t.closest('[data-gu-line]');
    if (line) {
      var input = $('[data-gu-qty-input]', line);
      var qty = input ? +input.value : +line.getAttribute('data-qty');
      if (t.closest('[data-gu-qty-minus]')) { updateLine(line, Math.max(0, qty - 1)); return; }
      if (t.closest('[data-gu-qty-plus]')) { updateLine(line, qty + 1); return; }
      if (t.closest('[data-gu-line-remove]')) { updateLine(line, 0); return; }
    } else {
      var qwrap = t.closest('.gu-qty');
      if (qwrap) {
        var qi = $('input', qwrap);
        if (qi && t.closest('[data-gu-qty-minus]')) { qi.value = Math.max(+qi.min || 1, (+qi.value || 1) - 1); return; }
        if (qi && t.closest('[data-gu-qty-plus]')) { qi.value = (+qi.value || 1) + 1; return; }
      }
    }

    if ((el = t.closest('.gu-swatch'))) { e.preventDefault(); activateSwatch(el); return; }
    if ((el = t.closest('[data-gu-copy]'))) {
      var code = el.getAttribute('data-gu-copy');
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { toast('Code kopiert: ' + code); });
      return;
    }
    if ((el = t.closest('[data-gu-modal-open]'))) {
      var dlg = d.getElementById(el.getAttribute('data-gu-modal-open'));
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    if ((el = t.closest('[data-gu-modal-close]'))) {
      var dl = el.closest('dialog');
      if (dl) dl.close();
      return;
    }
    if (t.matches && t.matches('dialog.gu-modal')) { t.close(); }
  });

  function updateLine(line, qty) {
    line.classList.add('is-loading');
    Cart.change(line.getAttribute('data-key'), qty).catch(function (err) {
      line.classList.remove('is-loading');
      lineError(err);
    });
  }

  d.addEventListener('change', function (e) {
    var t = e.target;
    var line = t.closest && t.closest('[data-gu-line]');
    if (line && t.matches('[data-gu-qty-input]')) { updateLine(line, Math.max(0, +t.value || 0)); return; }
    if (line && t.matches('[data-gu-line-option]')) {
      var box = t.closest('[data-gu-line-change]');
      var data = $('[data-gu-line-variants]', box);
      if (!data) return;
      var variants = JSON.parse(data.textContent);
      var current = +line.getAttribute('data-variant');
      var cur = variants.filter(function (v) { return v.id === current; })[0];
      if (!cur) return;
      var wanted = cur.o.slice();
      $$('[data-gu-line-option]', box).forEach(function (s) { wanted[+s.getAttribute('data-gu-line-option')] = s.value; });
      var match = variants.filter(function (v) { return v.o.every(function (o, i) { return o === wanted[i]; }); })[0];
      if (!match || match.id === current) return;
      if (!match.a) {
        toast((C.strings.unavailable || 'Nicht verfügbar') + ': ' + wanted.join(' / '));
        t.value = cur.o[+t.getAttribute('data-gu-line-option')];
        return;
      }
      line.classList.add('is-loading');
      Cart.swap(line.getAttribute('data-key'), +line.getAttribute('data-qty') || 1, match.id).catch(function (err) {
        line.classList.remove('is-loading');
        lineError(err);
      });
      return;
    }
    if (t.matches && t.matches('[data-gu-loc-select]')) { t.form.submit(); }
  });

  /* ---------- product card swatches ---------- */
  function activateSwatch(sw) {
    var card = sw.closest('[data-gu-card]');
    if (!card) return;
    $$('.gu-swatch', card).forEach(function (s) { s.classList.toggle('is-active', s === sw); });
    var img = $('.gu-card__img:not(.gu-card__img--hover)', card);
    var src = sw.getAttribute('data-src');
    if (img && src) {
      img.src = src;
      if (sw.getAttribute('data-srcset')) img.srcset = sw.getAttribute('data-srcset');
    }
    var url = sw.getAttribute('data-url');
    var link = $('[data-gu-card-link]', card);
    if (link && url) link.href = url;
  }
  d.addEventListener('mouseover', function (e) {
    if (!canHover()) return;
    var sw = e.target.closest && e.target.closest('.gu-swatch');
    if (sw && !sw.classList.contains('is-active')) activateSwatch(sw);
  });

  /* ---------- product page ---------- */
  function addBusinessDays(date, n) {
    var dt = new Date(date.getTime());
    var added = 0;
    while (added < n) {
      dt.setDate(dt.getDate() + 1);
      var wd = dt.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return dt;
  }
  function initDelivery(root) {
    $$('[data-gu-delivery]', root).forEach(function (el) {
      var raw = String(el.getAttribute('data-gu-delivery') || C.deliveryDefault || '5-10');
      var m = raw.match(/(\d+)\D+(\d+)/);
      var min = m ? +m[1] : (+raw || 5);
      var max = m ? +m[2] : min;
      var h = +C.handlingDays || 0;
      var now = new Date();
      var a = addBusinessDays(now, h + min);
      var b = addBusinessDays(now, h + max);
      var out = $('[data-gu-delivery-date]', el);
      if (!out) return;
      try {
        var f = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
        out.textContent = a.getTime() === b.getTime() ? f.format(a) : f.format(a) + ' – ' + f.format(b);
      } catch (err) { /* keep server text */ }
    });
  }

  function initProduct(sec) {
    if (sec._gu) return;
    sec._gu = true;
    var json = $('[data-gu-variants]', sec);
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var form = $('[data-gu-form]', sec);
    var idInput = form ? $('[data-gu-variant-id]', form) : null;
    var gallery = $('[data-gu-gallery]', sec);
    var current = variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || variants[0];

    // quantity-break block: the chosen tier sets the quantity that is added to the cart
    sec.addEventListener('change', function (e) {
      var r = e.target.closest && e.target.closest('input[data-gu-bundle-qty]');
      if (!r || !form) return;
      var q = form.querySelector('input[name="quantity"]');
      if (q) q.value = r.getAttribute('data-gu-bundle-qty');
    });
    function groups() { return $$('[data-gu-optgroup]', sec); }
    function selected() {
      return groups().map(function (g) {
        var c = $('input[data-gu-option]:checked', g);
        return c ? c.value : null;
      });
    }
    function findVariant(sel) {
      return variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
    }
    function markAvailability(sel) {
      groups().forEach(function (g, gi) {
        $$('input[data-gu-option]', g).forEach(function (inp) {
          var test = sel.slice();
          test[gi] = inp.value;
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return test[i] == null || o === test[i]; }); });
          var label = inp.closest('label');
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function render(v, sel) {
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      sec.classList.toggle('gu-on-sale', !!onSale);
      $$('[data-gu-bundle-opt]', sec).forEach(function (o) {
        var pct = +o.getAttribute('data-pct') || 0, qty = +o.getAttribute('data-qty') || 1;
        var unit = Math.floor(v.price * (100 - pct) / 100);
        var u = $('[data-gu-bundle-unit]', o), t = $('[data-gu-bundle-total]', o);
        if (u) u.textContent = money(unit);
        if (t) t.textContent = money(unit * qty);
      });
      $$('[data-gu-price]', sec).forEach(function (e) { e.textContent = money(v.price); });
      $$('[data-gu-compare]', sec).forEach(function (e) { e.hidden = !onSale; if (onSale) e.textContent = money(v.compare_at_price); });
      $$('[data-gu-save]', sec).forEach(function (e) { e.hidden = !onSale; });
      $$('[data-gu-save-pct]', sec).forEach(function (e) {
        if (onSale) e.textContent = '– ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
      });
      $$('[data-gu-atc-price]', sec).forEach(function (e) { e.textContent = money(v.price); });
      $$('[data-gu-atc-was]', sec).forEach(function (e) { e.hidden = !onSale; if (onSale) e.textContent = money(v.compare_at_price); });
      var avail = !!(v.available && v.id);
      $$('[data-gu-atc],[data-gu-sticky-atc]', sec).forEach(function (b) { b.disabled = !avail; });
      $$('[data-gu-atc-label]', sec).forEach(function (e) {
        e.textContent = avail ? e.getAttribute('data-add') : (v.id ? (C.strings.soldOut || 'Ausverkauft') : (C.strings.unavailable || 'Nicht verfügbar'));
      });
      (sel || v.options || []).forEach(function (val, i) {
        $$('[data-gu-opt-label="' + i + '"]', sec).forEach(function (e) { e.textContent = val || ''; });
      });
      $$('[data-gu-sticky-variant]', sec).forEach(function (e) { e.textContent = (sel || v.options || []).filter(Boolean).join(' / '); });
      $$('[data-gu-delivery]', sec).forEach(function (e) {
        e.classList.toggle('is-out', !avail);
        var title = $('[data-gu-delivery-title]', e);
        if (title) title.textContent = avail ? title.getAttribute('data-in') : title.getAttribute('data-out');
      });
    }
    function showMedia(mediaId) {
      if (!gallery || !mediaId) return;
      var item = $('[data-media-id="' + mediaId + '"]', gallery);
      if (!item) return;
      if (isDesktop()) {
        if (gallery.firstElementChild !== item) gallery.insertBefore(item, gallery.firstElementChild);
        var top = gallery.getBoundingClientRect().top + w.pageYOffset - (parseFloat(getComputedStyle(d.documentElement).getPropertyValue('--gu-hg')) || 110) - 12;
        if (w.pageYOffset > top) w.scrollTo({ top: top, behavior: 'smooth' });
      } else {
        gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      }
    }

    sec.addEventListener('change', function (e) {
      if (!e.target.matches('[data-gu-option]')) return;
      var sel = selected();
      var v = findVariant(sel);
      if (v) {
        current = v;
        if (idInput) idInput.value = v.id;
        var u = new URL(w.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u.toString());
        if (v.media) showMedia(v.media);
      } else {
        current = { id: null, available: false, price: current.price, compare_at_price: current.compare_at_price, options: sel };
      }
      render(current, sel);
      markAvailability(sel);
    });
    markAvailability(selected());
    render(current, selected());

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!current || !current.available || !current.id) return;
        var btn = $('[data-gu-atc]', form);
        var errBox = $('[data-gu-form-error]', form);
        if (errBox) errBox.hidden = true;
        if (btn) btn.classList.add('is-loading');
        Cart.add(new FormData(form))
          .then(function () {
            if (C.cartOpenOnAdd !== false && Cart.el()) Cart.open();
            else toast(C.strings.added || 'Zum Warenkorb hinzugefügt');
          })
          .catch(function (err) {
            var msg = (err && (err.description || err.message)) || C.strings.error;
            if (errBox) { errBox.textContent = msg; errBox.hidden = false; } else toast(msg);
          })
          .then(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    }

    var atc = $('[data-gu-atc]', sec);
    var sticky = $('[data-gu-sticky]', sec);
    if (atc && sticky && 'IntersectionObserver' in w) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', String(!past));
      }).observe(atc);
    }

    var pos = $('[data-gu-gallery-pos]', sec);
    if (gallery && pos) {
      gallery.addEventListener('scroll', function () {
        var i = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
        pos.textContent = i + 1;
      }, { passive: true });
    }

    var lb = $('[data-gu-lightbox]', sec);
    if (lb && lb.showModal) {
      var imgs = $$('[data-gu-lightbox-img]', lb);
      var idx = 0;
      var show = function (i) {
        if (!imgs.length) return;
        idx = (i + imgs.length) % imgs.length;
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === idx); });
      };
      sec.addEventListener('click', function (e) {
        var z = e.target.closest('[data-gu-zoom]');
        if (z) { show(+z.getAttribute('data-gu-zoom')); lb.showModal(); return; }
      });
      $('[data-gu-lightbox-close]', lb).addEventListener('click', function () { lb.close(); });
      $('[data-gu-lightbox-prev]', lb).addEventListener('click', function () { show(idx - 1); });
      $('[data-gu-lightbox-next]', lb).addEventListener('click', function () { show(idx + 1); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(idx - 1);
        if (e.key === 'ArrowRight') show(idx + 1);
      });
      var sx = null;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
        sx = null;
      });
    }
    initDelivery(sec);
  }

  /* ---------- collection / search: AJAX filters + load more ---------- */
  function formUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var base = form.getAttribute('action').split('?')[0];
    var s = params.toString();
    return base + (s ? '?' + s : '');
  }
  /* Promo tiles take a grid spot, so page 1 can end with a half-empty row before "Mehr laden". While more products
     follow, the trailing cards of an incomplete row are held back (not removed) and shown first on the next load —
     every row stays full on 2, 3 and 4 columns; on the last page everything is shown. */
  function fillRows(wrap) {
    var grid = $('[data-gu-grid]', wrap);
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.children);
    items.forEach(function (c) { if (c.hasAttribute('data-gu-carry')) { c.style.display = ''; c.removeAttribute('data-gu-carry'); } });
    if (!$('[data-gu-more-btn]', wrap)) return;
    var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
    var cards = items.filter(function (c) { return c.classList.contains('gu-grid__item'); });
    var extra = items.length % cols;
    if (extra && extra < cards.length) cards.slice(-extra).forEach(function (c) { c.style.display = 'none'; c.setAttribute('data-gu-carry', ''); });
  }
  function initResults(root) {
    var wrap = $('[data-gu-results]', root);
    if (!wrap || wrap._gu) return;
    wrap._gu = true;
    var sid = wrap.getAttribute('data-section-id');
    fillRows(wrap);
    var rt;
    w.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { fillRows(wrap); }, 150); });
    function load(url, push) {
      var u = new URL(url, w.location.origin);
      u.searchParams.set('section_id', sid);
      wrap.classList.add('is-loading');
      fetch(u.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = parseHTML(html).querySelector('[data-gu-results]');
          if (fresh) wrap.innerHTML = fresh.innerHTML;
          fillRows(wrap);
          u.searchParams.delete('section_id');
          if (push) history.pushState({ gu: true }, '', u.pathname + u.search);
        })
        .catch(function () { w.location.href = url; })
        .then(function () { wrap.classList.remove('is-loading'); });
    }
    function loadMore(btn) {
      var u = new URL(btn.href, w.location.origin);
      u.searchParams.set('section_id', sid);
      btn.classList.add('is-loading');
      btn.textContent = '…';
      fetch(u.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var grid = $('[data-gu-grid]', wrap);
          var freshGrid = doc.querySelector('[data-gu-grid]');
          if (grid && freshGrid) Array.prototype.slice.call(freshGrid.children).forEach(function (c) { grid.appendChild(c); });
          var more = $('[data-gu-more]', wrap);
          var freshMore = doc.querySelector('[data-gu-more]');
          if (more) {
            if (freshMore) more.innerHTML = freshMore.innerHTML;
            else more.remove();
          }
          fillRows(wrap);
        })
        .catch(function () { w.location.href = btn.href; });
    }
    wrap.addEventListener('change', function (e) {
      var form = e.target.closest('[data-gu-facets]');
      if (!form || e.target.type === 'number') return;
      load(formUrl(form), true);
    });
    wrap.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-gu-facets]');
      if (!form) return;
      e.preventDefault();
      load(formUrl(form), true);
    });
    wrap.addEventListener('click', function (e) {
      var a = e.target.closest('[data-gu-facet-link]');
      if (a) { e.preventDefault(); load(a.href, true); return; }
      var more = e.target.closest('[data-gu-more-btn]');
      if (more) { e.preventDefault(); loadMore(more); }
    });
    wrap.addEventListener('toggle', function (e) {
      var det = e.target;
      if (!det.matches || !det.matches('[data-gu-filter]') || !det.open) return;
      $$('[data-gu-filter][open]', wrap).forEach(function (o) { if (o !== det) o.open = false; });
    }, true);
    w.addEventListener('popstate', function (e) { if (e.state && e.state.gu) load(w.location.href, false); });
  }
  d.addEventListener('click', function (e) {
    var f = e.target.closest('.gu-filter');
    if (f) {
      if (e.target === f) f.open = false;
      return;
    }
    $$('[data-gu-filter][open]').forEach(function (o) { o.open = false; });
  });

  /* ---------- recommendations ---------- */
  function initRecs(root) {
    $$('[data-gu-recs]', root).forEach(function (sec) {
      if (sec._gu || !sec.getAttribute('data-url') || sec.children.length) return;
      sec._gu = true;
      fetch(sec.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = parseHTML(html).querySelector('[data-gu-recs]');
          if (fresh && fresh.innerHTML.trim()) sec.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  /* ---------- popup ---------- */
  function initPopup(root) {
    var p = $('[data-gu-popup]', root);
    if (!p || p._gu) return;
    p._gu = true;
    var key = 'gu-popup-closed';
    function open() { p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false'); lock(true); }
    function close() {
      if (!p.classList.contains('is-open')) return;
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
      lock(false);
      try { localStorage.setItem(key, String(Date.now())); } catch (e) { /* storage blocked */ }
    }
    $$('[data-gu-popup-close]', p).forEach(function (b) { b.addEventListener('click', close); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    p._guOpen = open;
    p._guClose = close;
    if ($('[data-gu-popup-success]', p)) { open(); return; }
    if (p.getAttribute('data-design') === 'true') return;
    if (p.getAttribute('data-mobile') === 'false' && !isDesktop()) return;
    var days = +p.getAttribute('data-days') || 14;
    var last = 0;
    try { last = +localStorage.getItem(key) || 0; } catch (e) { last = 0; }
    if (last && Date.now() - last < days * 864e5) return;
    setTimeout(open, (+p.getAttribute('data-delay') || 8) * 1000);
  }

  /* ---------- finder ---------- */
  function initFinder(root) {
    $$('[data-gu-finder]', root).forEach(function (form) {
      if (form._gu) return;
      form._gu = true;
      var group = $('[data-gu-finder-group]', form);
      var cat = $('[data-gu-finder-category]', form);
      if (group && cat) {
        group.addEventListener('change', function () {
          var g = group.value;
          $$('optgroup', cat).forEach(function (og) {
            var gid = og.getAttribute('data-group');
            var show = !g || gid === g || gid === '3';
            og.hidden = !show;
            og.disabled = !show;
          });
          var opt = cat.options[cat.selectedIndex];
          if (opt && opt.parentElement.disabled) cat.value = '';
        });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var base = cat && cat.value;
        if (!base && group && group.value) {
          var o = group.options[group.selectedIndex];
          base = o && o.getAttribute('data-url');
        }
        var url = new URL(base || form.getAttribute('action'), w.location.origin);
        var fd = new FormData(form);
        var price = fd.get('price');
        if (price) {
          var p = String(price).split('-');
          if (p[0]) url.searchParams.set('filter.v.price.gte', p[0]);
          if (p[1]) url.searchParams.set('filter.v.price.lte', p[1]);
        }
        var sort = fd.get('sort');
        if (sort) url.searchParams.set('sort_by', sort);
        w.location.href = url.pathname + url.search;
      });
    });
  }

  /* ---------- counters (stats) ---------- */
  function initCounters(root) {
    var els = $$('[data-gu-count]', root);
    if (!els.length || !('IntersectionObserver' in w)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target;
        var m = el.textContent.trim().match(/^(\d+)(.*)$/);
        if (!m) return;
        var end = +m[1];
        var suffix = m[2];
        var t0 = performance.now();
        (function step(t) {
          var p = Math.min(1, (t - t0) / 1200);
          el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))) + suffix;
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- footer accordions (mobile only; always open on desktop) ---------- */
  d.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('.gu-footer__h');
    if (sum && w.matchMedia('(min-width: 768px)').matches) e.preventDefault();
  });
  function initFooter(root) {
    var mq = w.matchMedia('(max-width: 767px)');
    if (mq.matches) {
      $$('.gu-footer__col[open]', root).forEach(function (det) { det.open = false; });
    }
    /* rotating a phone to landscape (>= 768 px) must open the columns again, and back */
    if (!w._guFooterMq && mq.addEventListener) {
      w._guFooterMq = true;
      mq.addEventListener('change', function (e) {
        $$('.gu-footer__col').forEach(function (det) { det.open = !e.matches; });
      });
    }
    /* "Cookie-Einstellungen": only where Shopify's consent banner is loaded (EU visitors) */
    $$('[data-gu-cookie-prefs]', root).forEach(function (btn) {
      var ready = function () { return w.privacyBanner && typeof w.privacyBanner.showPreferences === 'function'; };
      var reveal = function () { if (ready()) { btn.hidden = false; return true; } return false; };
      if (!reveal()) {
        var n = 0, t = setInterval(function () { if (reveal() || ++n > 20) clearInterval(t); }, 500);
      }
      btn.addEventListener('click', function () { if (ready()) w.privacyBanner.showPreferences(); });
    });
  }

  function initAll(root) {
    setHeaderHeight();
    initAnnouncement(root);
    initMega(root);
    initSearch(root);
    initFinder(root);
    initCounters(root);
    initResults(root);
    initRecs(root);
    initPopup(root);
    initFooter(root);
    initDelivery(root);
    $$('[data-gu-product]', root).forEach(initProduct);
  }

  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeMegas();
    closeDrawer();
    Cart.close();
  });
  w.addEventListener('resize', setHeaderHeight);
  w.addEventListener('load', setHeaderHeight);

  /* theme editor */
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  d.addEventListener('shopify:section:select', function (e) {
    var cd = $('[data-gu-cart-drawer]', e.target);
    if (cd) Cart.open();
    var p = $('[data-gu-popup]', e.target);
    if (p && p._guOpen) p._guOpen();
  });
  d.addEventListener('shopify:section:deselect', function (e) {
    if ($('[data-gu-cart-drawer]', e.target)) Cart.close();
    var p = $('[data-gu-popup]', e.target);
    if (p && p._guClose) p._guClose();
  });

  w.GU.cart = Cart;
  w.GU.money = money;
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { initAll(d); });
  else initAll(d);
})();
